import React, { useState, useMemo, FC } from 'react';
import classNames from 'classnames';

import Dropdown from '@sv-support-sdk/ui-components/src/components/Controls/Dropdown';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import Options from '../../../components/Lists/Options';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import chatsActions from '../../../store/actions/chats';
import ticketsActions from '../../../store/actions/tickets';
import { selectChatsMeta } from '../../../store/selectors/chats';
import { selectTicketsMeta } from '../../../store/selectors/tickets';

import css from '../style.module.scss';

interface IOption {
  [key: string]: any;
}

const sortingOptions = [
  { key: 'desc', name: 'Newest' },
  { key: 'asc', name: 'Oldest' },
];

interface IProps {
  type: 'chats' | 'tickets';
}

const SortingDropdown: FC<IProps> = ({ type }) => {
  const dispatch = useAppDispatch();
  const meta = useAppSelector(type === 'chats' ? selectChatsMeta : selectTicketsMeta);
  const [isOpened, setIsOpened] = useState(false);

  const selectSortBy = (option: IOption) => {
    const action = type === 'chats' ? chatsActions.getChats : ticketsActions.getTickets;

    dispatch(action({ order_by_direction: option.key }));
  };

  const sortBy = useMemo(() => {
    return sortingOptions.find(({ key }) => key === meta.orderByDirection) || sortingOptions[0];
  }, [meta]);

  return (
    <Dropdown
      options={sortingOptions}
      value={sortBy}
      trackBy="key"
      label="name"
      width="24"
      placement="right"
      onSelect={selectSortBy}
      onToggleList={setIsOpened}
      // @ts-expect-error expected error
      OptionsComponent={Options}
    >
      <div
        className={classNames(css.sortingDropdown__button, {
          [css.isActive]: isOpened,
        })}
      >
        <div className={css.sortingDropdown__button__icon}>
          <Icon id="24--sort-outline" />
        </div>
      </div>
    </Dropdown>
  );
};

export default SortingDropdown;
